package us.laantech.admin.api

import us.laantech.admin.ENV
import kotlinx.browser.window

actual fun getAuthorizationCodeFromUrl(): String? {
    val search = window.location.search
    if (search.isNullOrBlank()) return null
    return search.removePrefix("?")
        .split("&")
        .firstOrNull { it.startsWith("code=") }
        ?.substringAfter("code=")
        ?.takeIf { it.isNotBlank() }
}

actual fun clearAuthorizationCodeFromUrl() {
    window.history.replaceState(null, "", window.location.pathname)
}

actual suspend fun startOAuthLogin(): String? {
    window.location.href = ENV.COGNITO_LOGIN_PAGE
    return null
}